// ── Finance.js — shell: tab router only ──────────────────────────────────────
import { useState } from 'react';
import { C, useIsMobile, PillToggle } from './financeUtils';
import SupplierSpendTab from './SupplierSpendTab';
import PLTab            from './PLTab';
import CashForecastTab  from './CashForecast';

export default function FinancePage({ currentUser }) {
  const isMobile = useIsMobile();
  const [tab, setTab] = useState('spend');
  const role = currentUser?.role || 'admin';

  return (
    <div style={{ padding: isMobile ? '1rem' : '1.25rem', maxWidth: 1200, margin: '0 auto', minHeight: '100vh' }}>
      <div style={{ marginBottom: '1.1rem' }}>
        <div style={{ fontSize: isMobile ? '1.1rem' : '1.25rem', fontWeight: 800, color: C.ink, letterSpacing: '-0.02em' }}>Finance</div>
        <div style={{ fontSize: '0.78rem', color: C.mid, marginTop: 2 }}>Live data · Lekker Mate B.V. via Xero</div>
      </div>
      <div style={{ marginBottom: '1.25rem' }}>
        <PillToggle
          options={[
            { key: 'spend',    label: 'Supplier Spend' },
            { key: 'pl',       label: 'P&L' },
            { key: 'forecast', label: 'Cash Forecast' },
          ]}
          value={tab}
          onChange={setTab}
        />
      </div>
      {tab === 'spend'    && <SupplierSpendTab role={role} />}
      {tab === 'pl'       && <PLTab />}
      {tab === 'forecast' && <CashForecastTab />}
    </div>
  );
}